import clsx from 'clsx';

import Icon from '../Icon';
import Input from '../Input';

const SearchBar: typeof Input = ({
  value,
  onChange,
  inputClassName,
  ...props
}) => {
  return (
    <Input
      placeholder="Search"
      {...props}
      value={value}
      onChange={onChange}
      inputClassName={clsx(inputClassName, 'pr-xl')}
      suffix={
        value &&
        !!String(value).length && (
          <Icon
            icon="clear"
            onClick={() => onChange?.('')}
            className="cursor-pointer opacity-80 hover:opacity-100"
          />
        )
      }
    />
  );
};

export default SearchBar;
